import { CALL_API } from '../../middlewares/api';

import {
    FAILURE_RETAGGAGE,
    RECEIVE_RETAGGAGE,
    REQUEST_RETAGGAGE,
    REQUEST_BYPASS_ADBLOCKER,
    RECEIVE_BYPASS_ADBLOCKER,
    FAILURE_BYPASS_ADBLOCKER
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

/**
 * dispatch async action to get url rewritten for tracking
 * @param {*} partnerId
 * @param {*} couponId
 * @param {*} clickSource
 * @param {*} urlOverride urlSource given in url parameter, can be empty
 * @param {*} username username pass in url from email
 * @param {*} toolbarRequest true when its a toolbar request, otherwise false
 * @param {*} isAdblockerDetectedOrCookiesDisabled define if the request was made from a toolbar or no
 * @param {*} successCallback
 * @param {*} errorCallback
 */
export const doRewriteUrl = (
    partnerId,
    couponId,
    clickSource,
    urlOverride,
    username,
    toolbarRequest,
    adblockerDetectedOrCookiesDisabled,
    successCallback,
    errorCallback
) => {
    return {
        [CALL_API]: {
            endpoint: `/rewrite${username ? `/${username}` : ''}`,
            types: [REQUEST_RETAGGAGE, RECEIVE_RETAGGAGE, FAILURE_RETAGGAGE],
            method: HTTP_METHOD_POST,
            authenticated: !username,
            body: {
                partnerId,
                couponId,
                clickSource,
                urlOverride,
                toolbarRequest,
                adblockerDetectedOrCookiesDisabled
            },
            successCallback: successCallback,
            errorCallback: errorCallback
        }
    };
};

export const traceBypassAdblocker = (trackingCode, successCallback) => {
    return {
        [CALL_API]: {
            endpoint: `/trace/adblocker/confirm`,
            types: [REQUEST_BYPASS_ADBLOCKER, RECEIVE_BYPASS_ADBLOCKER, FAILURE_BYPASS_ADBLOCKER],
            body: {
                trackingCode
            },
            successCallback: successCallback
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/interstitiel/actions.js